<template>
  <li class="login-sns-each">
    <component
      :is="buttonComponents[snsType]"
      v-bind="$props"
      @success="onSuccessConnect"
      @fail="onFailConnect"
    />
  </li>
</template>

<script setup>
  import KakaoButton from '@/components/oauth/KakaoButton.vue'
  import NaverButton from '@/components/oauth/NaverButton.vue'
  import AppleButton from '@/components/oauth/AppleButton.vue'
  import FacebookButton from '@/components/oauth/FacebookButton.vue'
  import TidButton from '@/components/oauth/TidButton.vue'
  import { removeProperties, findQueryParam } from '@/common/utils/common'
  import { useRoute, useRouter } from 'vue-router/composables'

  const props = defineProps({
    snsType: {
      type: String,
      default: '',
    },
    useMemberWeb: {
      type: Boolean,
      default: false,
    },
    useReferer: {
      type: Boolean,
      default: false,
    },
    useReturnUrl: {
      type: Boolean,
      default: true,
    },
  })

  const emit = defineEmits(['success', 'fail'])
  const route = useRoute()
  const router = useRouter()

  const deleteSnsLoginParams = async () => {
    if (!findQueryParam('type') || !findQueryParam('token')) {
      return
    }
    const resultQuery = removeProperties(route.query, ['type', 'token'])
    await router
      .replace({
        query: resultQuery,
      })
      .catch(() => {})
  }

  const onSuccessConnect = async ({ token }) => {
    if (!token) {
      deleteSnsLoginParams()
      return
    }
    emit('success', { token, type: props.snsType })
  }

  const onFailConnect = () => {
    if (!findQueryParam('type')) {
      return
    }
    const resultQuery = removeProperties(route.query, ['type'])
    router.replace({
      query: resultQuery,
    })
  }

  const buttonComponents = {
    kakao: KakaoButton,
    naver: NaverButton,
    apple: AppleButton,
    facebook: FacebookButton,
    tid: TidButton,
  }
</script>

<style lang="scss" scoped></style>
